<script setup lang="ts">
  const props = defineProps<{
    modelValue: boolean
  }>()

  const emit = defineEmits<{
    (event: 'update:modelValue', payload: boolean): void
  }>()

  const onChange = (event: Event) => {
    if (event.target instanceof HTMLInputElement) {
      emit('update:modelValue', event.target.checked)
    }
  }
  // handling the enter and space on tab accessibility
  const handleKeydown = (event: KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      emit('update:modelValue', !props.modelValue)
    }
  }
</script>

<template>
  <label
    class="relative inline-block h-[24px] min-w-[44px] max-w-[44px]"
    tabindex="0"
    @keydown="handleKeydown"
  >
    <input
      class="peer h-0 w-0 opacity-0"
      type="checkbox"
      :checked="modelValue"
      @change="onChange"
    />
    <span
      class="absolute inset-0 cursor-pointer rounded-3xl duration-[0.4s] bg-background-neutral-subtle before:duration[0.4s] before:transition-transform before:absolute before:bottom-1 before:left-1 before:h-4 before:w-4 before:rounded-[50%] before:bg-white before:peer-checked:translate-x-[20px] peer-focus:shadow[0 0 1px accent-action-primary-default] peer-checked:bg-action-primary-default dark:peer-focus:shadow[0 0 1px accent-action-primary-default] dark:bg-radio_group_bg_color"
    />
  </label>
</template>
